// extracted by mini-css-extract-plugin
export var banner = "_p7-0";
export var settingRow = "_p7-2";
export var titleIcon = "_p7-1";